import React from 'react';
import styled from '@emotion/styled';

import { getVariantTitle, getVariantImageUrl } from '../../../helpers';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .card-box-styled {
    padding: 1.5rem 0 0.5rem 0;
  }
  .variant-list-header {
    display: flex;
    padding: 0 1.5rem;
    margin-bottom: 15px;
    .add-button-wrapper {
      margin-top: -9px;
      margin-left: auto;
    }
  }
  .variant-row {
    border-top: 1px solid #dee2e6;
    padding: 10px 0;
    border-left: 3px solid #fff;
    img {
      width: inherit;
    }
    margin: 0;
    align-items: center;
    cursor: pointer;
    &:hover,
    &.active {
      color: #7e57c2;
      border-left: 3px solid #7e57c2;
      font-weight: 600;
    }
  }

  @media (max-width: 1310px) {
    .variant-list-header {
      display: block;
      .add-button-wrapper {
        margin-top: 10px;
        margin-left: 0;
      }
    }
  }

  @media (max-width: 993px) {
    .variant-list-header {
      display: flex;
      .add-button-wrapper {
        margin-top: -9px;
        margin-left: auto;
      }
    }
  }
`;

const VariantsList = (props) => {
  const { isNew, product, features, currentVariant, setCurrentVariant, handleCloneVariant } = props;

  const { t } = useAutoTranslation();

  return (
    <Wrapper className="row">
      <div className="col-12">
        <div className="card-box card-box-styled">
          <div className="variant-list-header">
            <div>
              <h4 className="header-title">{t('Монокороба')}</h4>
            </div>

            {/* //! Не работает. ПОпробовать робросить parentPackageId в запрос */}
            {/* {!isNew ? (
              <div className="add-button-wrapper">
                <button
                  type="button"
                  className="btn btn-danger waves-effect waves-light"
                  onClick={handleCloneVariant}
                >
                  <i className="fe-file-plus" /> Добавить
                </button>
              </div>
            ) : null} */}
          </div>
          {product.variants
            .filter((v) => v.parentPackageId)
            .map((v) => (
              <div
                key={v.id}
                className={`row variant-row ${
                  currentVariant && v.id === currentVariant.id ? 'active' : ''
                }`}
                onClick={() => setCurrentVariant(v.id)}
              >
                <div className="col-3">
                  <img src={getVariantImageUrl(v, 250)} />
                </div>
                <div className="col-9">{v.shortName}</div>
              </div>
            ))}
        </div>
      </div>
    </Wrapper>
  );
};

export default VariantsList;
